import {action, makeObservable, observable, runInAction } from "mobx";
import type { IOption } from "../../../components/inputs/select-dropdown/select-dropdown";
import UserMasterListService, { ILoginRole, userMaserListSearchParams} from "../../../services/api/user-master-list-service";
import {rootContainer, TYPE} from "../../../services/container/root";
import PagedDataStore, {IFetchListArgs, IPagedData} from "../../../stores/abstract-paged-data-store";
import UserRowStore from "./user-row-store";

export const SearchFiltersList: IOption[] = [
	{label: 'All Users', value: 'all'},
	{label: 'Only Shops', value: 'Shops'},
	{label: 'Only Owners', value: 'Owners'},
];

export enum ADMIN_ROLE_NAMES {
	VIEWER = 'viewer',
	EDITOR = 'editor',
}

export interface IUserMasterListStore {
}

export class UserMasterListStore  extends PagedDataStore<UserRowStore> implements IUserMasterListStore {
	@observable private _searchUserType: IOption = SearchFiltersList.find(x => x.value === 'Shops')!;
	@observable private _searchValue: string = '';
	@observable private _loginRoles: ILoginRole[] = [];

	constructor() {
		super();
		makeObservable(this);
	}
	private get service(): UserMasterListService {return rootContainer.get<UserMasterListService>(TYPE.UserMasterListService);}

	public async fetchList(args?: IFetchListArgs): Promise<IPagedData<UserRowStore>> {
		if(args === undefined){
			args = {
                page: 1,
                perPage: 50,
				sortBy: 'id',
				sortDir: 'desc',
            };
		}

		this._isLoading = true;
		let res = await this.service.fetchList(this.getSearchParams(), args);

		return {
			...res,
			data: res.data.map((user) => new UserRowStore(user, this))
		}
	}

    public async reloadByIds(userIds: Array<number>) {
		try {
			this._isLoading = true;
			const users = await this.service.fetchListByIds(userIds);
			runInAction(() => {
				this._isLoading = false;
				users.forEach((user) => {
					const storeIndex = this._list.findIndex(userRowStore => userRowStore.id === user.id);
					if(storeIndex >= 0) {
						this._list[storeIndex] = new UserRowStore(user, this);
					}
				});
			});
		}
		catch(e) {
			runInAction(() => {
				this._isLoading = true;
			});
		}
    }

	public get isLoading(): boolean {return this._isLoading;}
	public setLoading(isLoading: boolean) {this._isLoading = isLoading;}
	public get searchUserType(): IOption {return this._searchUserType;}
	public get searchValue():string{ return this._searchValue;}
	public set searchValue(value:string){  this._searchValue = value;}

	@action
	public setSearchUserType(searchUserType: IOption) {this._searchUserType = searchUserType;}
	private getSearchParams(): userMaserListSearchParams {
		return {
			searchUserType: this._searchUserType.value as string,
			searchValue: this._searchValue
		}
	}

	public get viewerRole(): ILoginRole | undefined {
		return this._loginRoles.find(role => role.name.toLowerCase() === ADMIN_ROLE_NAMES.VIEWER);
	}

	public get editorRole(): ILoginRole | undefined {
		return this._loginRoles.find(role => role.name.toLowerCase() === ADMIN_ROLE_NAMES.EDITOR);
	}

	@action
	public async fetchLoginRoles(): Promise<void> {
		if (this._loginRoles.length > 0) {
			return;
		}

        try {
            const roles = await this.service.fetchLoginRoles();
            runInAction(() => {
                this._loginRoles = roles;
            });
        }
        catch (e) {
            console.error(e);
        }
	}
}

export default new UserMasterListStore();